module.exports = __webpack_public_path__ + "static/media/cox.0c2f644c.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/june-5/races/images/cox.png
// module id = 637
// module chunks = 46 48 55 57